{
  "Automatic ({language})": "Automatique ({language})",
  "Language": "Langue",
  "Cancel": "Annuler",
  "OK": "OK",
  "Ok": "OK",
  "Okay": "OK",
  "Yes": "Oui",
  "No": "Non",
  "Save": "Enregistrer",
  "Saved": "Enregistré",
  "Saving...": "Enregistrement...",
  "Saving…": "Enregistrement…",
  "Delete": "Supprimer",
  "Remove": "Retirer",
  "Edit": "Modifier",
  "Change": "Changer",
  "Close": "Fermer",
  "Done": "OK",
  "Back": "Retour",
  "Next": "Suivant",
  "Continue": "Continuer",
  "Skip": "Passer",
  "Retry": "Réessayer",
  "Try again": "Réessayer",
  "Please try again.": "Veuillez réessayer.",
  "Please try again": "Veuillez réessayer",
  "Something went wrong": "Une erreur s’est produite",
  "Something went wrong. Please try again.": "Une erreur s’est produite. Veuillez réessayer.",
  "Error": "Erreur",
  "Loading...": "Chargement...",
  "Loading…": "Chargement…",
  "Share": "Partager",
  "Copy": "Copier",
  "Copy link": "Copier le lien",
  "Copied": "Copié",
  "Copied!": "Copié !",
  "Link copied": "Lien copié",
  "Open": "Ouvrir",
  "Restore": "Restaurer",
  "Learn more": "En savoir plus",
  "More": "Plus",
  "Help": "Aide",
  "Settings": "Paramètres",
  "Open Settings": "Ouvrir les paramètres",
  "Profile": "Profil",
  "Email": "E-mail",
  "Password": "Mot de passe",
  "Name": "Nom",
  "Title": "Titre",
  "Location": "Lieu",
  "Date and time": "Date et heure",
  "Privacy": "Confidentialité",
  "Embed": "Embed",
  "Branding": "Personnalisation",
  "Logo": "Logo",
  "Guestbook": "Livre d’or",
  "Fundraising": "Collecte de fonds",
  "Pricing": "Tarifs",
  "Plans": "Forfaits",
  "EventLive Plans": "Forfaits EventLive",
  "My Events": "Mes événements",
  "Event link": "Lien de l’événement",
  "Event title": "Titre de l’événement",
  "Go Live": "Passer en direct",
  "Watch Live": "Regarder en direct",
  "Live only": "En direct uniquement",
  "Start free test": "Lancer un test gratuit",
  "Free test": "Test gratuit",
  "Unlock event": "Débloquer l’événement",
  "Unlock": "Débloquer",
  "Sell Tickets": "Vendre des billets",
  "Video Wall": "Mur de vidéos",
  "Manage Video": "Gérer la vidéo",
  "Upload video": "Importer une vidéo",
  "What's new": "Nouveautés",
  "What's New": "Nouveautés",
  "Camera": "Caméra",
  "Required": "Obligatoire",
  "Terms": "Conditions",
  "Monthly": "Mensuel",
  "Unlimited": "Illimité",
  "Not found": "Introuvable",
  "Not signed in": "Connexion requise",
  "Please sign in again.": "Veuillez vous reconnecter.",
  "Too many requests. Please wait a moment and try again.": "Trop de demandes. Veuillez patienter un instant, puis réessayer.",
  "Welcome to EventLive": "Bienvenue sur EventLive",
  "Today": "Aujourd’hui",
  "Tomorrow": "Demain",
  "Yesterday": "Hier",
  "MMM D, YYYY": "D MMM YYYY",
  "MMM D": "D MMM",
  "h:mm A": "HH:mm",
  "h:mm a": "HH:mm",
  "Test Event": "Événement test"
}
